<template><!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 16.1 20" style="enable-background:new 0 0 16.1 20;" xml:space="preserve">
<path d="M8,0L8,0c0.8,0,1.5,0.1,2.3,0.4c2,0.7,3.6,2.3,4.3,4.3C14.9,5.5,15,6.2,15,7c0,6,0,6,0,6c0,0.8-0.1,1.5-0.4,2.3
	c-0.7,2-2.3,3.6-4.3,4.3C9.5,19.9,8.8,20,8,20l0,0c-0.8,0-1.5-0.1-2.3-0.4c-2-0.7-3.6-2.3-4.3-4.3C1.1,14.5,1,13.8,1,13c0-6,0-6,0-6
	c0-0.8,0.1-1.5,0.4-2.3c0.7-2,2.3-3.6,4.3-4.3C6.5,0.1,7.2,0,8,0z" fill="currentColor"/>
</svg>
</template>